<template>
    <div class="simple-container flexible-container" data-testid="activity-report-simple-total-work">
        <div>{{ t('projectclient.activitytracker.total') }}</div>
        <div>{{ totalText }}</div>
    </div>
</template>
<script setup lang="ts">
    import {useTranslation} from '#imports';
    import type {WorkedUnit} from '@api';
    import {useFormatTotalText} from '../../utils';

    const {t} = useTranslation();

    const props = defineProps<{
        time: number;
        unit: WorkedUnit;
    }>();

    const totalText = useFormatTotalText(props.time, props.unit);
</script>
<style lang="scss" scoped>
    .simple-container {
        border: 1px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
        font-weight: var(--joy-font-weight-bold);
        font-size: var(--joy-font-size-primary-600);
        margin-bottom: var(--joy-core-spacing-4);
    }
</style>
